/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import isEmpty from 'lodash/isEmpty';
import { apiHelpers } from 'ui-lottery/src/api/helpers';
import * as endpoints from './endpoints';

const { get, getWithAuth, postWithAuth, post } = apiHelpers(SecurityHelper);

// Reservations
export const getReservation = (resId) =>
    getWithAuth(endpoints.reservationEndpoint(resId));
export const createReservation = (res) =>
    postWithAuth(endpoints.reservationsEndpoint(), res);
export const updateReservation = (res) =>
    postWithAuth(endpoints.reservationsEndpoint(), res);

export const getReservations = (resIds) =>
    getWithAuth(endpoints.reservationsEndpoint(resIds));
export const createReservations = (reservations, recaptcha) =>
    postWithAuth(
        endpoints.reservationsEndpoint(),
        // When recaptcha is enabled we send the wrapped request shape the
        // recaptcha-aware service expects; otherwise we fall back to the legacy
        // bare-array body so the UI stays compatible with an older service.
        !isEmpty(recaptcha)
            ? {
                  reservations,
                  profile: recaptcha.profile,
                  admin: recaptcha.admin,
              }
            : reservations
    );

export const getPrice = (request) => postWithAuth(endpoints.priceEndpoint(), request);

export const validateReservation = (request) =>
    post(endpoints.validateEndpoint(), request);

// Pass Types
export const getPassTypes = (facilityId) => get(endpoints.passTypesEndpoint(facilityId));
export const getPassType = (passTypeId) => get(endpoints.passTypeEndpoint(passTypeId));

// Facilities
export const getFacilities = () => getWithAuth(endpoints.facilitiesEndpoint());
export const getFacility = (facilityId) =>
    getWithAuth(endpoints.facilityEndpoint(facilityId));
export const getFacilityByIdOrSlug = (facilityId) =>
    getWithAuth(endpoints.facilityByIdOrSlugEndpoint(facilityId));
export const getFacilityPassTypesOffline = (facilityId) =>
    getWithAuth(endpoints.facilityPassTypesOfflineEndpoint(facilityId));
export const getLocationAsset = (id) => getWithAuth(endpoints.location(id));

// parent asset
export const getParentAsset = (id) => getWithAuth(endpoints.recarea(id));
export const getParentInventory = (id) => getWithAuth(endpoints.inventory(id));
export const validatePassReminder = (payload) =>
    postWithAuth(endpoints.reminderEndpoint(), payload);

// accounts
export const verifyAddress = (address) =>
    postWithAuth(endpoints.verifyAddressEndpoint(), address);
